import { defineStore } from "pinia";
import { instance } from "..";

export enum ELoader {
  DEFAULT,
  CHAPTERS,
  TRAILS,
  MATERIALS,
  QUIZ,
  MATERIAL,
  PERCENTAGE,
  ALERT
}

export const store = defineStore({
  id: "adapt-loader",
  state: () => ({
    load: {} as Record<ELoader | string, boolean>,
  }),
  actions: {
    start(key: ELoader = ELoader.DEFAULT) {
      this.load[key] = true;
    },
    stop(key: ELoader = ELoader.DEFAULT) {
      let debounceTimer: number | null = null;
      debounceTimer = setTimeout(() => (this.load[key] = false), 250);
    },
  },
});

export const useAdaptLoaderStore = store(instance);
